import { apiClient } from '@/lib/api-client';
import type { SmsConfigMasked, UpsertSmsConfigInput, TestSmsResult } from '@bbpos/types';

export const smsService = {
  getConfig() {
    return apiClient<SmsConfigMasked>('/integrations/sms/config');
  },

  upsertConfig(input: UpsertSmsConfigInput) {
    return apiClient<SmsConfigMasked>('/integrations/sms/config', {
      method: 'PUT',
      body: input,
    });
  },

  testConfig() {
    return apiClient<TestSmsResult>('/integrations/sms/config/test', { method: 'POST' });
  },

  deactivateConfig() {
    return apiClient<{ deactivated: boolean }>('/integrations/sms/config', {
      method: 'DELETE',
    });
  },
};
